export const stripHtmlTags = (html: string | unknown): string => {
  if (!html) return '';
  if (typeof html !== 'string') return String(html);
  return html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/<[^>]*>/g, '');
};
